module.exports = __webpack_public_path__ + "static/img/finger-key2.97f1c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/finger/finger-key2.jpg
// module id = T96u
// module chunks = 0